<div dir="ltr" style="background-color: white;">
    <h1 style="text-align: center; font-weight: bold; color: #5c5e60; padding-top: 0.5%;" translate>Service Assistant
    </h1>
    <span layout="row">
      <hr class="divhr" flex/>
  </span>
    <div class="divv">
        <div class="content">
            <div fxLayout="row wrap" fxLayoutGap="14px grid" style="justify-content:center">


                <div fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                    <a [queryParams]="{ id: commonCode.Terminologie }" [routerLink]="['/portail', 'Terminologie']"
                       class="st-p">
                        <mat-card class="mat-elevation-z0 st-matcard">
                            <img class="st-matcardimage" mat-card-image src="assets/images/terminologie.svg">
                            <mat-card-content>

                                <p class="st-p-matcard">
                                    {{ "Terminologie_f" | translate}}

                                </p>
                            </mat-card-content>
                        </mat-card>
                    </a>
                </div>


                <div fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                    <a [queryParams]="{ id: commonCode.GuideUtilisateur }" [routerLink]="['/portail', 'Videotheque']"
                       class="st-p">

                        <mat-card class="mat-elevation-z0 st-matcard">
                            <img class="st-matcardimage" mat-card-image src="assets/images/video.svg">

                            <mat-card-content>

                                <p class="st-p-matcard">
                                    {{ "Videothéque" | translate}}

                                </p>
                            </mat-card-content>
                        </mat-card>
                    </a>
                </div>
                <div fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">

                    <a [routerLink]="['/portail/faq']" class="st-p">

                        <mat-card class="mat-elevation-z0 st-matcard">
                            <img class="st-matcardimage" mat-card-image src="assets/images/faq.svg">
                            <mat-card-content>

                                <p class="st-p-matcard">
                                    {{ "faq" | translate}}
                                </p>
                            </mat-card-content>
                        </mat-card>
                    </a>
                </div>

                <div fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                    <a [routerLink]="['/portail/qna']" class="st-p">
                        <mat-card class="mat-elevation-z0 st-matcard">
                            <img class="st-matcardimage" mat-card-image src="assets/images/questionreponse.svg">
                            <mat-card-content>

                                <p class="st-p-matcard">
                                    {{ "qna" | translate}}
                                </p>
                            </mat-card-content>
                        </mat-card>
                    </a>
                </div>
                <div fxFlex="20%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                    <a [queryParams]="{ id: commonCode.CentreApppel }" [routerLink]="['/portail', 'contact']"
                       class="st-p">
                        <mat-card class="mat-elevation-z0 st-matcard">
                            <img class="st-matcardimage" mat-card-image src="assets/images/contact.svg">
                            <mat-card-content>

                                <p class="st-p-matcard">
                                    {{ "contact" | translate}}
                                </p>
                            </mat-card-content>
                        </mat-card>
                    </a>
                </div>

            </div>
        </div>


    </div>

</div>


